module.exports = __webpack_public_path__ + "img/header-diamondJewelry100Carat.2a51558.webp";